import { consumption_type_enum } from '@predium/enums';
import { ReactElement } from 'react';
import { IconConsumptionElectricity } from '@/assets/Icons/consumption/electricity';
import { IconConsumptionHeating } from '@/assets/Icons/consumption/heating';
import { IconConsumptionWaste } from '@/assets/Icons/consumption/waste';
import { IconConsumptionWater } from '@/assets/Icons/consumption/water';
import { IconColors } from '@/components/ColoredLabel';

export function getIconForConsumptionType(consumptionType: consumption_type_enum) {
  return (
    {
      [consumption_type_enum.HEATING]: <IconConsumptionHeating />,
      [consumption_type_enum.ELECTRICITY]: <IconConsumptionElectricity />,
      [consumption_type_enum.WATER]: <IconConsumptionWater />,
      [consumption_type_enum.WASTE]: <IconConsumptionWaste />,
    } satisfies Record<consumption_type_enum, ReactElement>
  )[consumptionType];
}

export function getIconThemeColor(consumptionType: consumption_type_enum): IconColors {
  return (
    {
      [consumption_type_enum.HEATING]: 'error',
      [consumption_type_enum.ELECTRICITY]: 'warning',
      [consumption_type_enum.WATER]: 'info',
      [consumption_type_enum.WASTE]: 'success',
    } satisfies Record<consumption_type_enum, IconColors>
  )[consumptionType];
}
